/**
 * Derives display initials from a display name or email fallback.
 * - Display name: first letter of first word + first letter of last word (uppercased)
 * - Email fallback: first character of the email address (uppercased)
 * - Final fallback: 'U'
 */
export const getInitials = (displayName?: string | null, email?: string | null): string => {
  if (displayName) {
    const parts = displayName.trim().split(/\s+/)
    const first = parts[0]?.[0] ?? ''
    const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : ''
    return (first + last).toUpperCase() || 'U'
  }
  return email?.[0]?.toUpperCase() ?? 'U'
}
